import { Add, Place } from "@mui/icons-material";
import React, { useContext, useEffect, useState } from "react";
import SimpleWidgetsHeader from "../../../../components/SimpleWidgetsHeader/SimpleWidgetsHeader";
import { PosContext } from "../../../../shared/PosContext";
import { parseAddress } from "../../../../utils/floorUtils";
import { useStyles } from "./styles";
import NewAddress from "./NewAddress";

const CustomerAddress = ({ onClose, onSelect, customerName }) => {
    const classes = useStyles();
    const { addresses } = useContext(PosContext);

    const [addView, setAddView] = useState(false);

    const addressDialogAction = {
        callback: () => {
            setAddView(true);
        },
        Icon: Add,
    };

    const handleBack = () => {
        setAddView(false);
    };

    const handleAddressSelect = (address) => {
        onSelect?.(customerName, address.name)
        setAddView(false);
    };

    const handleClick = (addressName) => {
        onSelect?.(customerName, addressName);
    };

    return (
        <div className={classes.AddressDialog}>
            <SimpleWidgetsHeader
                title="Customer Address"
                Icon={Place}
                onClose={addView ? handleBack : onClose} //TODO REMOVE addView
                action={!addView && addressDialogAction}
            />
            <div className={`${classes.List} compact`}>
                <div className="List_Items">
                    {!addView &&
                        addresses &&
                        addresses[customerName] &&
                        addresses[customerName].map((address) => (
                            <div
                                key={address.name}
                                className="List__Row"
                                onClick={() => handleClick(address.name)}
                            >
                                <div>{parseAddress(address)}</div>
                            </div>
                        ))}
                    {addView && (
                        <NewAddress
                            customerName={customerName}
                            onClose={handleBack}
                            onCreate={handleAddressSelect}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default CustomerAddress;
